import React, { Suspense } from 'react';
import HashLoaderBackdrop from 'src/shared/HashLoaderBackdrop';

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<HashLoaderBackdrop />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
